
import qrcode from 'qrcode'
import Api from '@/Plugins/api'

const state = () => ({
  /**
   * The invoice's signature.
   * @type String
   */
  signature: undefined,
})

const getters = {
  business: (state, getters, rootState, rootGetters) => prop => rootGetters['rummage/business'](prop),

  ticketInfo: state => null,

  invoiceInfo: (state, getters, rootState, rootGetters) => rootGetters['translate']('original'),

  _taxAdministration: (state, getters, rootState, rootGetters) => rootGetters['fiscalCountry/config']('tax_administration'),

  _url: (state, getters) => [
    'https://ticketbai.araba.eus/TBAI/QRTBAI', // alaba
    'https://batuz.eus/QRTBAI/',               // bizkaia
    'https://tbai.egoitza.gipuzkoa.eus/qr/',   // gipuzkoa
  ][getters._taxAdministration ?? 0],

  _license: (state, getters) => [
    'TBAIARCFFbdbggj00278', // alaba
    'TBAIGI703EBABD506330', // bizkaia
    'TBAIGI703EBABD506330', // gipuzkoa
  ][getters._taxAdministration ?? 0],

  fiscalInfo: (state, getters, rootState) => [
    { title: 'developmentEntity', value: ['Revo Systems, S.L.', 'B66353780'] },
    { title: 'softwareName', value: 'Revo XEF (Handy)' },
    { title: 'serialNumber', value: rootState.UUID },
    { title: 'license', value: getters._license },
  ],

  fiscalData: state => null,

  orderMaxAmount: (state, getters, rootState, rootGetters) => rootGetters['fiscalCountry/spain/orderMaxAmount'],
  contentPrice: state => payload => null,

  shouldAddReason: state => false,
  shouldSignInvoice: state => true,
}

const mutations = {
  signature (state, value) {
    state.signature = value
  },
}

const actions = {
  printPreHeader ({}, { order, invoice }) {},
  printAdditionalHeader ({}, business) {},
  printAdditionalFooter ({}, business) {},
  printCheckSummary ({ dispatch }, order) {
    return dispatch('fiscalCountry/spain/printCheckSummary', order, { root: true })
  },
  async printInvoiceSummary ({ dispatch }, { order, invoice }) {
    await dispatch('fiscalCountry/spain/printInvoiceSummary', { order, invoice }, { root: true })
    if (invoice.accountable) {
      await dispatch('_printQR', invoice)
    }
  },
  signPrintCheck ({}, { order, reason }) {},
  async signInvoice ({ commit, dispatch, rootState }, invoice) {
    if (invoice.notAccountable) {
      return
    }
    try {
      const response = await Api(['fiscalCountry', 'SignInvoice'], {
        id: invoice.id,
        cashier_id: rootState.user.data.cashier_id || rootState.settings.values.cashier,
      })
      commit('signature', response.data.signature)
    } catch (e) {
      dispatch('$log', 'Failed to get fiscal country signature', { root: true })
      throw e
    }
  },
  async _printQR ({ dispatch, rootGetters }, invoice) {
    const qr = await dispatch('_qr', invoice)
    if (! qr) {
      return
    }
    AndroidPrinter.separator('-')
    AndroidPrinter.text(qr.id)
    try {
      AndroidPrinter.image64(await qrcode.toDataURL(qr.url, {
        errorCorrectionLevel: 'M',
        margin: 2,
      }))
    } catch (err) {
      dispatch('log', { action: 'Cannot print the invoice QR: ' + err, model: 'Order', model_id: invoice.order_id }, { root: true })
      dispatch('alert/showError', rootGetters['translate']('printError'), { root: true })
    }
  },
  _qr ({ state, getters }, invoice) {
    if (! state.signature) {
      throw new Error('The invoice is unsigned')
    }

    const nif = getters['business']('nif')
    const date = invoice.dateMoment.format('DDMMYY')
    const signature = state.signature?.slice(0, 13) ?? ''
    const identifier = `TBAI-${nif}-${date}-${signature}-`
    const id = identifier + identifier.crc8().toString().padStart(3, '0')

    const qs = new URLSearchParams({
      id,
      s: new String(invoice.prefix ?? '').replaceAll(' ', '+'),
      nf: invoice.withoutPrefix ?? invoice.number,
      i: Math.roundToCurrency(invoice.total).toFixed(2),
    })

    const url = getters['_url'] + '?' + qs.toString()
    const crc = url.crc8().toString().padStart(3, '0')

    return {
      id,
      url: `${url}&cr=${crc}`,
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
